import { CardBrands } from 'types';
import { IFormMccCard } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import AdditionalMccCard from './components/AdditionalMccCard';
import MainMccCard from './components/MainMccCard';
import React from 'react';
import style from './CardBrand.module.scss';

interface ICardBrand {
	mccCards: IFormMccCard[];
	selectedMainMccCardBrand: CardBrands | null;
	reservedMccCardBrands: (CardBrands | null)[];
	changeMainMccCardBrand: (value: CardBrands) => void;
	changeMainMccCardMcc: (value: Nullable<number>) => void;
	changeMccCardBrand: (id: string, value: CardBrands) => void;
	changeMccCardMcc: (id: string, value: Nullable<number>) => void;
	addMccCard: (value: IFormMccCard) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
	deleteMccCard: (id: string) => void;
	isShowAdditionalMccCards: boolean;
	useCustomerMcc: boolean;
}

const CardBrand: React.FC<ICardBrand> = ({
	mccCards,
	selectedMainMccCardBrand,
	reservedMccCardBrands,
	changeMccCardBrand,
	changeMccCardMcc,
	changeMainMccCardBrand,
	changeMainMccCardMcc,
	addMccCard,
	setShowAdditionalMccCards,
	deleteMccCard,
	isShowAdditionalMccCards,
	useCustomerMcc,
}) => {
	return (
		<div className={style.container}>
			<MainMccCard
				mccCards={mccCards}
				selectedMainMccCardBrand={selectedMainMccCardBrand}
				reservedMccCardBrands={reservedMccCardBrands}
				changeMainMccCardMcc={changeMainMccCardMcc}
				changeMainMccCardBrand={changeMainMccCardBrand}
				addMccCard={addMccCard}
				setShowAdditionalMccCards={setShowAdditionalMccCards}
				useCustomerMcc={useCustomerMcc}
			/>
			{mccCards.map((el) => (
				<AdditionalMccCard
					key={el.id}
					fieldId={el.id}
					selectedAdditionalMccCardBrand={el.brand}
					reservedMccCardBrands={reservedMccCardBrands}
					isShowAdditionalMccCards={isShowAdditionalMccCards}
					changeMccCardMcc={changeMccCardMcc}
					changeMccCardBrand={changeMccCardBrand}
					deleteMccCard={deleteMccCard}
					setShowAdditionalMccCards={setShowAdditionalMccCards}
					useCustomerMcc={useCustomerMcc}
				/>
			))}
		</div>
	);
};

export default React.memo(CardBrand);
